import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Table,Form, Button, Spinner } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import styles from './style.module.scss';
import CampaignRequestService from '../../services/campaign-request';
import ResalesRequestService from '../../services/resales-request';
import ManufacturersRequestService from '../../services/manufacturers-request';
import {maskDocument, documentType, maskZip} from 'helpers/document';
import { useParams } from 'react-router-dom';
import { setContext } from 'redux-saga/effects';
import Select from 'react-select'
import makeAnimated from 'react-select/animated';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.min.css";
import BootstrapTable from 'react-bootstrap-table-next';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight,faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import loading from 'store/reducers/loading';

const CamapignsShow = () => {
  const [reports, setReports] = useState({data:[]});
  const [reportsListResales, setReportsListResales] = useState({data:[]});
  const [reportsListResalesSelected, setReportsListResalesSelected] = useState({data:[]});
  
  const [campaign, setCampaign] = useState({
    start_at:'',
    end_at:'',
    manufacturer_id:null
  });

  const [listCompany,setListCompany] = useState([]);
  const [listCompanySelected,setListCompanySelect] = useState([]);
  const [fixedListSelected, setFixedListSelected] = useState(null);

  const [manufacturers,setManufacturers] = useState([]);

  const defaultFilters = {
    segment:[0],
    client_type:[0],
    status:[0],
    bu:[0],
    class:[0]
  };
  const [filters, setFilters] = useState(defaultFilters);
  const [info, setInfo] = useState({segment:[],client_type:[],status:[],bu:[],class:[]});
  const [erroRequired, setErroRequired] = useState({campos:[],erro:false})

  const [disabledButton, setDisabledButton] = useState(true);

  const [loadingResales, setLoadingResales] = useState(false);

  const [bus, setBus] = useState([]);
  const [saveBu, setSaveBu] = useState({functionSave:null,verificar:null})

  const [formEdit, setFormEdit] = useState(false);
  const [wasModified, setWasModified] = useState(false);
  const [messageErro, setMessageErro] = useState(false);

  const [title,setTitle] = useState('');


  useEffect(() => {
    var params = getParams();
    setTitle('Criar');
    if(params.id!=null){
      let campaign = CampaignRequestService.getCapaign(params.id);
      campaign.then(data => {
        setReports(data);
      });
      let companies = CampaignRequestService.getCampaignCompanies(params.id);
      companies.then(data => {
        setReportsListResalesSelected(data);
      });
    }
    let listManufact = ManufacturersRequestService.getAll();
    listManufact.then(data => {
      setManufacturers(Object.values(data.data).map(m=>{
        return {
          value: m.id, label: m.name
        };
      }));
    })
    let companiesInfo = ResalesRequestService.getInfoResale();
    companiesInfo.then(data => {
      setInfo(data.data);
    });
  }, []);

  useEffect(() => {
    let model = {...campaign};
    if(reports.data[0]){
      setTitle('Editar');
      setLoadingResales(true);
      getCompanies(reports.data[0].manufacturer_id);
      model.start_at = new Date(reports.data[0].start_at);
      model.end_at = new Date(reports.data[0].end_at);
      model.manufacturer_id = reports.data[0].manufacturer_id;
      model.id = reports.data[0].id;
    }
    setCampaign(model);
  }, [reports,formEdit,wasModified,erroRequired]);

  useEffect(()=>{
    setListCompany(Object.values(reportsListResales.data).filter(c=>{
      if(Object.values(filters.segment).indexOf(0)==-1)
        if(filters.segment.length>0 && Object.values(filters.segment).indexOf(c.segment_id)==-1)
          return false;
      if(Object.values(filters.bu).indexOf(0)==-1)
        if(filters.bu.length>0 && Object.values(filters.bu).indexOf(c.bu_principal_id)==-1)
          return false;
      if(Object.values(filters.client_type).indexOf(0)==-1)
        if(filters.client_type.length>0 && Object.values(filters.client_type).indexOf(c.client_type_id)==-1)
          return false;
      
      if(Object.values(filters.class).indexOf(0)==-1)
      if(filters.class.length>0){
        let v1 = c.premium,v2 = c.vip;
        var v = 0;
        if(v2==null || v2==0){
          if(v1==0)
            v = 1;
          else 
            v = 2;
        } else {
          v = 3;
        }
        if(Object.values(filters.class).indexOf(v)==-1)
          return false;
      }
      return true;
    }).map(c =>{
      return {
        value:c.id,
        label:c.name+' - '+c.document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
      };
    }));
  }, [reportsListResales, filters]);

  useEffect(()=>{
    setListCompanySelect(Object.values(reportsListResalesSelected.data).map($a=>{
      return $a.id;
    }));
    setFixedListSelected(Object.values(reportsListResalesSelected.data).map($a=>{
      return $a.id;
    }));
  }, [reportsListResalesSelected]);

  const getCompanies = (id) => {
    setReportsListResales({data:[]});
    let companies = ResalesRequestService.getByManufacturer(id);
    companies.then(data => {
      setReportsListResales(data);
      setLoadingResales(false);
    });
  }

  const getParams = (model) =>{
    const queryString = window.location.search;
    var lista = queryString.replace('?','').split('&');
    let retorno = {}; 
    lista.forEach(p=>{
      let k = p.split('=');
      retorno[k[0]] = k[1];
    });
    return retorno; 
  }

  const verificarDisabledButton = () => {
    var vazio = false;
    Object.keys(campaign).forEach(k=>{
      if(campaign[k] == '' || campaign[k] == 0 || campaign[k] == null){
        vazio = true;
      }
    });
    if(listCompanySelected.length==0 || reportsListResales.data.length==0)
      vazio = true;
    return vazio;
  };

  const save = () =>{
    document.getElementById('btn-save').disabled=true;
    var vazio = false;
    Object.keys(campaign).forEach(k=>{
      if(campaign[k] == '' || campaign[k] == 0 || campaign[k] == null){
        vazio = true;
      }
    });
    if(!vazio){

      var model = {...campaign};
      var id = null;
      if(model.id!=null){
        id = model.id;
        delete model.id;
      }
      model.resales = {
        insert:[],
        delete:[]
      };
      
      fixedListSelected.forEach(company_id=>{
        //ver se existe
        let i = listCompanySelected.indexOf(company_id);
        if(i===-1){
          model.resales.delete.push(company_id)
        }
      });
      listCompanySelected.forEach(company_id=>{
        //ver se existe
        let i = fixedListSelected.indexOf(company_id);
        if(i===-1){
          model.resales.insert.push(company_id)
        }
      });
      
      var request = CampaignRequestService.saveCampaign(id,model);
      request.then(data => {
        window.location.href = './';
      });
    }
    document.getElementById('btn-save').disabled=false;
  };

  const getInfo = name => {
    return [...Object.values(info[name]).map(i=>{
      return {value:i.id,label:i.name};
    }), {value:0,label:'Todos'}];
  };

  const filter=(values,name)=>{
    if(values!=null && values.length > 0){
      let c = {...filters};
      if(c[name].indexOf(0)!=-1){
        c[name] = values.filter(c=>{
          var retorno = true;
          if(values.length>1){
            retorno = c.value === 0?false:true;
          }
          return retorno;
        }).map(v=>{return v.value});
      } else {
        var retorno = values.filter(c=> c.value === 0).length==1;
        if(!retorno) retorno = values.length === info[name].length; 
        c[name] = retorno?[0]:values.map(v=>{return v.value});
      }
      setFilters(c);
    } else {
      let c = {...filters};
      c[name] = [0];
      setFilters(c);
    }
  };

  const getValueFilter=(name)=>{
    return filters[name].map(a=>{
      return getInfo(name).filter(c=>c.value === a)[0];
    });
    
  };

  const animatedComponents = makeAnimated();

  return (
    <>
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <Card.Body>
                <Row>
                  <Col className="align-self-center">
                    <h3 className={styles.headerTitle}>
                      Campanha
                    </h3>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <hr className={styles.line} />
                  </Col>
                </Row>
                <Card>
                  <Card.Body>
                    <Container>
                      <Row>
                        <Col>
                          <p className="font-weight-bold">{title} Campanha</p>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={6}>
                          <Form.Group>
                            <Form.Label>Marca:</Form.Label>
                            <Select options={manufacturers} 
                            value={manufacturers.filter(option => option.value === campaign.manufacturer_id)} 
                            placeholder={'selecione'}
                            isLoading={loadingResales}
                            isDisabled={campaign.id}
                            onChange={(value)=>{
                              let c = {...campaign};
                              c.manufacturer_id = value.value;
                              setCampaign(c);
                              getCompanies(c.manufacturer_id);
                              setLoadingResales(true);
                            }}/>
                          </Form.Group>
                        </Col>
                        <Col xs={3}>
                          <Form.Group>
                            <Form.Label>Data Inicio:</Form.Label>
                            <DatePicker
                            className="form-control"
                            minDate={new Date()}
                            selected={campaign.start_at}
                            onChange={date => {
                              let c = {...campaign};
                              c.start_at = date;
                              if(c.start_at > c.end_at){
                                c.end_at='';
                              }
                              setCampaign(c);
                            }}

                            />
                          </Form.Group>
                        </Col>
                        <Col xs={3}>
                          <Form.Group>
                            <Form.Label>Data Final:</Form.Label>
                            <DatePicker
                            className="form-control"
                            disabled={campaign.start_at==''}
                            minDate={new Date(campaign.start_at)}
                            selected={campaign.end_at}
                            onChange={date => {
                              let c = {...campaign};
                              c.end_at = date;
                              setCampaign(c);
                            }}
                            />
                          </Form.Group>
                        </Col>
                        <Col xs={12}>
                          <Form.Group>
                            <Form.Label>Revendas:</Form.Label>
                        {loadingResales?(
                          <Row className="d-flex justify-content-center">
                            <Spinner animation="border"/>
                          </Row>
                        ):
                        (campaign.manufacturer_id!=null?(
                          reportsListResales.data.length==0?(
                            <Row>
                              <Col className="border p-3">
                              <p className="text-center m-0" style={{padding:'1px 214px'}}>Não existem revendas que trabalharam com a marca escolhida nos últimos 6 meses</p>
                              </Col>
                            </Row>
                          ):(
                          <>
                          <Row>
                            <Col xs={5}>
                              <Form.Group>
                                <Form.Label>Classificação:</Form.Label>
                                <Select 
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti={true}
                                options={getInfo('class')} 
                                //defaultValue={}
                                value={getValueFilter('class')}
                                placeholder={'selecione'}
                                onChange={(values)=>{
                                  filter(values,'class');
                                }}/>
                              </Form.Group>
                            </Col>
                            <Col xs={5}>
                              <Form.Group>
                                <Form.Label>Segmento:</Form.Label>
                                <Select 
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti={true}
                                options={getInfo('segment')} 
                                value={getValueFilter('segment')}
                                placeholder={'selecione'}
                                onChange={(values)=>{
                                  filter(values,'segment');
                                }}/>
                              </Form.Group>
                            </Col>
                            <Col xs={5}>
                              <Form.Group>
                                <Form.Label>Bu:</Form.Label>
                                <Select 
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti={true}
                                options={getInfo('bu')} 
                                value={getValueFilter('bu')}
                                placeholder={'selecione'}//value={manufacturers.filter(option => option.value === campaign.manufacturer_id)} placeholder={'selecione'}
                                onChange={(values)=>{
                                  filter(values,'bu');
                                }}/>
                              </Form.Group>
                            </Col>
                            <Col xs={5}>
                              <Form.Group>
                                <Form.Label>Tipo de cliente:</Form.Label>
                                <Select 
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti={true}
                                options={getInfo('client_type')} 
                                value={getValueFilter('client_type')}
                                placeholder={'selecione'}
                                onChange={(values)=>{
                                  filter(values,'client_type');
                                }}/>
                              </Form.Group>
                            </Col>
                            <Col xs={5}></Col>
                          </Row>
                          <DualListBox
                            className="table"
                            canFilter
                            filterCallback={(option, filterInput) => {
                              if (filterInput === '') {
                                  return true;
                              }
                              return (new RegExp(filterInput, 'i')).test(option.label);
                            }}
                            filterPlaceholder="Pesquisa"
                            options={listCompany}
                            selected={listCompanySelected}
                            onChange={(selected) => {
                              setListCompanySelect(selected);
                            }}
                            icons = { {
                              moveLeft : <FontAwesomeIcon icon={faChevronLeft}/>,   
                              moveAllLeft : [ 
                                <FontAwesomeIcon key={0} icon={faChevronLeft}/>,
                                <FontAwesomeIcon key={1} icon={faChevronLeft}/>,
                              ] ,
                              moveRight : <FontAwesomeIcon icon={faChevronRight}/>,   
                              moveAllRight : [ 
                                <FontAwesomeIcon key={0} icon={faChevronRight}/>,
                                <FontAwesomeIcon key={1} icon={faChevronRight}/>,
                              ] ,
                              moveDown : < span className = " fa fa-chevron-down " /> ,   
                              moveUp : < span className = " fa fa-chevron-up " /> ,   
                          } }
                          />
                          </>
                          
                        )
                          ):(
                            <Row>
                              <Col className="border p-3">
                              <p className="text-center m-0">Selecione uma marca para prosseguir</p>
                              </Col>
                            </Row>
                          ))}
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                      <Col className="d-flex justify-content-end">
                        <Form.Group>
                          <Button variant="dark"
                            id="btn-save"
                            onClick={()=>{
                              save();
                            }}
                            disabled={verificarDisabledButton()}>
                            {title} Campanha
                          </Button>
                        </Form.Group>
                      </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </Card.Body> 
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default MasterPage(CamapignsShow);